import React from 'react';
import PropertyCard from '@organisms/property/card';
import IsOwnerBanner from "@molecules/banners/is.owner";
import {array_chunk, is_array} from "@helpers/arrays";
import SearchHotLinks from "../search_hot_links";
import LoadMore from "../../property/load.more";
import InvestmentBanner from "../../../molecules/banners/investment_banner";
import MostActiveAgencies from "../../property/components/most_active_agencies";
import {inArray} from "../../../helpers/arrays";



const SearchPropertyListCards = ({properties, isBadeSaba, filters, checkShowInvestBanner, handleBookmark, bookmarkedProperties, hotLinks, categories, selectedFiltersDistrictIds, userContext, handleShowProperty, handleGetProperties, windowSize, setForceShowNoResult, setContactInfo}) => {
    let hotlinksPage = 0;
    let hotlinksItems = [];
    if (is_array(hotLinks) && hotLinks.length) {
        hotlinksItems = array_chunk(hotLinks, 4);
    }

    return (
        <div className="row mt-md-0">
            <div className="col-12">
                {
                    (properties.length) ?
                        <React.Fragment>
                            {
                                array_chunk(properties, 20).map((chunk, propertiesPage) => {
                                    return (
                                        chunk.map((property, key) => {
                                            const chunkLength = chunk.length;
                                            const loop = (key + 1);

                                            let itemCount = 5;
                                            let $hotLinksPosition = 'end';
                                            let $hotLinksPosition2 = null;
                                            let $realtorBannerPosition = 'end';
                                            let $createPropertyPosition = 'end';
                                            let $investmentBannerPosition = 'end';


                                            if (chunkLength >= 10) {
                                                if (chunkLength < 15) {
                                                    $hotLinksPosition = 'between';
                                                    $realtorBannerPosition = 'end';
                                                } else if (chunkLength < 20) {
                                                    $hotLinksPosition = 'between';
                                                    $hotLinksPosition2 = 'end';
                                                    $realtorBannerPosition = 'between';
                                                } else {
                                                    $hotLinksPosition = 'between';
                                                    $hotLinksPosition2 = 'between';
                                                    $realtorBannerPosition = 'between';
                                                }
                                            }

                                            if (chunkLength >= 7) {
                                                $createPropertyPosition = 'between';
                                            }

                                            if (windowSize < 768) {
                                                itemCount = 4;
                                                $investmentBannerPosition = 'between'
                                            }

                                            hotlinksPage = propertiesPage;
                                            if (hotLinks.length < ((propertiesPage + 1) * 8)) {
                                                hotlinksPage = 0;
                                            }

                                            return (
                                                <React.Fragment>

                                                    <PropertyCard
                                                        mapKey={property.id}
                                                        property={property}
                                                        categories={categories}
                                                        setForceShowNoResult={setForceShowNoResult}
                                                        setContactInfo={setContactInfo}
                                                        selectedFiltersDistrict={filters.selected_filters.district_id}
                                                        selectedCityFilter={filters.selected_filters.city_id}
                                                        handleBookmark={handleBookmark}
                                                        bookmarkedProperties={bookmarkedProperties}
                                                        handleShowProperty={handleShowProperty}
                                                        isBadeSaba={isBadeSaba}
                                                    />

                                                    {
                                                        (is_array(hotlinksItems) && hotlinksItems.length) ?
                                                            <React.Fragment>
                                                                {
                                                                    (categories === 'search' &&
                                                                        (
                                                                            ($hotLinksPosition === 'end' && loop >= chunkLength) ||
                                                                            ($hotLinksPosition === 'between' && loop === itemCount)
                                                                        )
                                                                    ) ?
                                                                        <SearchHotLinks
                                                                            className="mx-24 mx-md-0"
                                                                            items={(hotlinksItems[(hotlinksPage * 2)] && hotlinksItems[(hotlinksPage * 2)].length ? hotlinksItems[(hotlinksPage * 2)] : [])}/>
                                                                        : ''
                                                                }

                                                                {
                                                                    (categories === 'search' &&
                                                                        (
                                                                            ($hotLinksPosition2 === 'end' && loop >= chunkLength) ||
                                                                            ($hotLinksPosition2 === 'between' && loop === (windowSize > 767 ? 3 : 4) * itemCount)
                                                                        )
                                                                    ) ?
                                                                        <SearchHotLinks
                                                                            className="mx-24 mx-md-0"
                                                                            items={(hotlinksItems[(hotlinksPage * 2) + 1] && hotlinksItems[(hotlinksPage * 2) + 1].length ? hotlinksItems[(hotlinksPage * 2) + 1] : [])}/>
                                                                        : ''
                                                                }
                                                            </React.Fragment>
                                                            : ''
                                                    }


                                                    {
                                                        (!isBadeSaba && categories === 'search' && (($realtorBannerPosition === 'end' && loop >= chunkLength) || ($realtorBannerPosition === 'between' && loop === (windowSize > 767 ? 2 : 3) * itemCount))) ?
                                                            <MostActiveAgencies
                                                                className="py-32 pb-md-40 border-bottom"
                                                                city_id={filters.selected_filters.city_id}
                                                                district_id={selectedFiltersDistrictIds}
                                                                setContactInfo={setContactInfo}
                                                                count={(inArray(filters.selected_filters.city_id, [3198, 17879]) ? 28 : 12)}
                                                            />
                                                            : ''
                                                    }

                                                    {
                                                        (!isBadeSaba && categories === 'search' && windowSize < 768 && !userContext.check && (($createPropertyPosition === 'end' && loop >= chunkLength) || ($createPropertyPosition === 'between' && loop === 5 * itemCount))) ?
                                                            <div className="mx-24 mx-md-0 py-24 py-lg-32 d-md-none border-bottom border-gray200">
                                                                <IsOwnerBanner/>
                                                            </div>
                                                            : ''
                                                    }

                                                    {
                                                        (categories === 'search' && !userContext.isRealtor && checkShowInvestBanner.show_invest && (($investmentBannerPosition === 'end' && loop >= chunkLength) || ($investmentBannerPosition === 'between' && loop === (2 * itemCount)))) ?
                                                            <div className="mx-24 mx-md-0 py-24 py-lg-32 border-bottom border-gray200">
                                                                <InvestmentBanner
                                                                    eventSection="properties"
                                                                    eventView="list"
                                                                    isBadeSaba={isBadeSaba}
                                                                    userModality={checkShowInvestBanner}/>
                                                            </div>
                                                            : ''
                                                    }
                                                </React.Fragment>
                                            )
                                        })
                                    )
                                })
                            }

                            <div className="my-56"/>
                            <LoadMore handleGetProperties={handleGetProperties} className={(isBadeSaba ? 'pb-56 mb-56' : '')}/>
                            <div className="my-56"/>
                        </React.Fragment>
                        :
                        ''
                }
            </div>
        </div>
    );
};

export default React.memo(SearchPropertyListCards);

